import React from 'react';
import { Row, Col } from 'antd';
import { BInput } from 'common/components';
import { BusinessLine, Clients } from 'RootModule/catalogs';

const Client = ({ form, detailPricesData }) => {
  const autoSelectOnlyOption = (options) => {
    if (options.length === 1) {
      form.setFieldsValue({ clientLineId: options[0].key });
    }
  };

  const handleLinkedSelect = (linked, value) => {
    if (typeof value !== 'object') {
      form.setFieldsValue({ [linked]: value });
    }
  };
  return (
    <div>
      <Row>
        <Col span={8}>
          <Clients
            label="Sold to"
            isRequired
            optionKey="soldTo"
            valueKey="soldTo"
            labelKey="soldTo"
            sourceId="BySoldTo"
            name="soldTo"
            allowClear={false}
            onChange={(value) => handleLinkedSelect('clientName', value)}
            disabled={true}
          />
        </Col>
        <Col span={8}>
          <Clients
            label="Nombre"
            isRequired
            optionKey="name"
            valueKey="soldTo"
            labelKey="name"
            sourceId="BySoldTo"
            name="clientName"
            allowClear={false}
            onChange={(value) => handleLinkedSelect('soldTo', value)}
            disabled={true}
          />
        </Col>
        <Col span={8}>
          <BusinessLine
            isRequired
            sourceId="Fixed"
            allowClear={false}
            requestParams={{ clientSoldTo: detailPricesData?.soldTo }}
            onSuccess={autoSelectOnlyOption}
            name="clientLineId"
            askFromService={detailPricesData?.soldTo}
            disabled
          />
        </Col>
        <Col span={8}>
          <BInput label="Tipo" name="type" disabled />
        </Col>
      </Row>
    </div>
  );
};

export default Client;
